import { token } from '@trello/theme';
import type { GetDynamicTokens } from './getDynamicTokens';

export const getDynamicNavItemTokens: GetDynamicTokens<'dynamic.navitem'> = ({
  background: { backgroundBrightness },
  theme,
  shouldUseDarkThemeOverride,
}) => {
  if (theme === 'dark' && shouldUseDarkThemeOverride) {
    return {
      'dynamic.navitem': token(
        'color.background.neutral.subtle',
        'transparent',
      ),
      'dynamic.navitem.hovered': token(
        'color.background.neutral.subtle.hovered',
        '#a1bdd914',
      ),
      'dynamic.navitem.pressed': token(
        'color.background.neutral.subtle.pressed',
        '#a6c5e229',
      ),
    };
  }

  if (theme === null) {
    if (backgroundBrightness === 'dark') {
      return {
        'dynamic.navitem': 'transparent',
        'dynamic.navitem.hovered': 'hsla(0,0%,100%,0.16)',
        'dynamic.navitem.pressed': 'hsla(0,0%,100%,0.3)',
      };
    } else {
      return {
        'dynamic.navitem': 'transparent',
        'dynamic.navitem.hovered': 'hsla(0,100%,0%,0.08)',
        'dynamic.navitem.pressed': 'hsla(0,100%,0%,0.16)',
      };
    }
  }

  if (backgroundBrightness === 'dark') {
    return {
      'dynamic.navitem': 'transparent',
      // Equivalent to --ds-background-neutral-subtle-hovered in ADS dark mode:
      'dynamic.navitem.hovered': '#A1BDD914',
      // Equivalent to --ds-background-neutral-subtle-pressed in ADS dark mode:
      'dynamic.navitem.pressed': '#A6C5E229',
    };
  } else {
    return {
      'dynamic.navitem': 'transparent',
      // Equivalent to --ds-background-neutral-subtle-hovered in ADS light mode:
      'dynamic.navitem.hovered': '#091E420F',
      // Equivalent to --ds-background-neutral-subtle-pressed in ADS light mode:
      'dynamic.navitem.pressed': '#091E4224',
    };
  }
};
